function getFontSizeValue(size, theme) {
  return theme.fn.size({ size, sizes: theme.fontSizes });
}

export { getFontSizeValue };
//# sourceMappingURL=get-font-size-value.js.map
